/**
 * Dashboard components
 */
import { createRouter, createWebHistory } from 'vue-router';

const baseUrl = '/dashboard';
const dashboardRouter = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: `${baseUrl}/my-hub`,
      name: 'MyHub',
      component: () => import(/* webpackChunkName: "group-dashboard" */'@/components/dashboard/my-hub/hub.vue'),
    },
    {
      path: `${baseUrl}/saved-items`,
      redirect: { name: 'saved-jobs' },
      name: 'SavedItems',
      component: () => import(/* webpackChunkName: "group-dashboard" */'@/components/dashboard/saved-items/index.vue'),
      children: [
        {
          path: 'saved-jobs',
          name: 'saved-jobs',
          component: () => import(/* webpackChunkName: "group-dashboard" */'@/components/dashboard/saved-items/index.vue'),
          children: [
            { path: ':id/:type', name: 'user-inputs', component: () => import(/* webpackChunkName: "group-dashboard" */'@/components/dashboard/saved-items/index.vue') },
          ],
        },
        { path: 'saved-reviews', name: 'saved-reviews', component: () => import(/* webpackChunkName: "group-dashboard" */'@/components/dashboard/saved-items/index.vue') },
        { path: 'saved-companies', name: 'saved-companies', component: () => import(/* webpackChunkName: "group-dashboard" */'@/components/dashboard/saved-items/index.vue') },
      ],
    },
    {
      path: `${baseUrl}/my-reviews`,
      component: () => import(/* webpackChunkName: "group-dashboard" */'@/components/dashboard/reviews/my-reviews.vue'),
      children: [
        { path: '', name: 'reviews' },
      ],
    },
    // {
    //   path: '/saved-searches',
    //   component: SavedSearchIndex,
    //
    //   children: [
    //     { path: ':id', name: 'saved-search-edit', component: SavedSearchIndex },
    //     { path: '', name: 'saved-searches', component: SavedSearchIndex },
    //   ],
    // },
    {
      path: `${baseUrl}/contact-preferences`,
      component: () => import(/* webpackChunkName: "group-dashboard" */'@/components/dashboard/contact-preferences/contact-preferences.vue'),

      children: [
        { path: '', name: 'contact-preferences', component: () => import(/* webpackChunkName: "group-dashboard" */'@/components/dashboard/contact-preferences/contact-preferences.vue') },
      ],
    },
    {
      path: `${baseUrl}/personal-information`,
      redirect: { name: 'basic-info' },
      component: () => import(/* webpackChunkName: "group-dashboard" */'@/components/dashboard/personal-info/personal-info.vue'),

      children: [
        { path: 'basic-info', name: 'basic-info', component: () => import(/* webpackChunkName: "group-dashboard" */'@/components/dashboard/personal-info/personal-info.vue') },
        { path: 'job-preferences', name: 'job-preferences', component: () => import(/* webpackChunkName: "group-dashboard" */'@/components/dashboard/personal-info/personal-info.vue') },
        { path: 'diversity', name: 'diversity', component: () => import(/* webpackChunkName: "group-dashboard" */ '@/components/dashboard/personal-info/personal-info.vue') },
      ],
    },
    {
      path: `${baseUrl}/data-security`,
      component: () => import(/* webpackChunkName: "group-dashboard" */'@/components/dashboard/data-security/data-security.vue'),

      children: [
        { path: '', name: 'data-security', component: () => import(/* webpackChunkName: "group-dashboard" */'@/components/dashboard/data-security/data-security.vue') },
      ],
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: { name: 'MyHub' },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

export default dashboardRouter;
